// import React, { useEffect, useState } from "react";
// import Table from "react-bootstrap/Table";
// import Modal from "react-bootstrap/Modal";
// import Button from "react-bootstrap/Button";
// import Form from "react-bootstrap/Form";
// import { useNavigate } from "react-router-dom";
// import "./SubmittedApplications.css";
// import NavigationBar from "../../Components/NavigationBar";
 

// export default function SubmittedApplications() {
//   const [applications, setApplications] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [awards, setAwards] = useState([]);
//   const [selectedAward, setSelectedAward] = useState("");
//   const [selectedYear, setSelectedYear] = useState("");
//   const navigate = useNavigate();
//   const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL;
//   const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

//   const userId = localStorage.getItem("user_id");

//   useEffect(() => {
//     fetch(`${API_BASE_URL}/getApplicationsByUser/${userId}`)
//       .then((res) => res.json())
//       .then((data) => {
//         setApplications(data);
//       })
//       .catch((err) => console.error("Error fetching applications:", err));
//   }, [userId]);

  

//   const handleUploadAgreement = () => {
//     setShowModal(true);
//   };

//   const handleFileChange = (event) => {
//     setSelectedFile(event.target.files[0]);
//   };

//   const handleFileUpload = () => {
//     if (!selectedFile) {
//       alert("Please select a file to upload.");
//       return;
//     }
//     alert("File uploaded successfully!");
//     setShowModal(false);
//     setSelectedFile(null);
//   };

 

//   const handleDeleteClick = () => {
//     if (window.confirm("Are you sure you want to delete this application?")) {
//       alert("Application deleted successfully.");
//     }
//   };

//   return (
//     <div>
//       <NavigationBar />
//       <h1 className="page-name">Submitted Applications</h1>
//       <Table
//         striped
//         bordered
//         hover
//         style={{
//           marginTop: "20px",
//           boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
//         }}
//       >
//         <thead>
//           <tr>
//             <th>Application Id</th>
//             <th>Name</th>
//             <th>Award Type</th>
//             <th>Submitted Date</th>
//             <th>View Application</th>
//             <th>Status</th>
//           </tr>
//         </thead>
//         <tbody>
//           {applications.length === 0 ? (
//             <tr>
//               <td colSpan="6" style={{ textAlign: "center" }}>
//                 No applications submitted.
//               </td>
//             </tr>
//           ) : (
//             applications.map((app) => (
//               <tr key={app.Application_Id}>
//                 <td>{app.Application_Id}</td>
//                 <td>{app.Name}</td>
//                 <td>{app.Award_Type}</td>
//                 <td>{app.SubmittedDate}</td>
//                 <td>
//                   <button
//                     className="View_Button"
//                     onClick={() => {
//                       const formattedAwardType = app.Award_Type.replace(
//                         /\s+/g,
//                         "_"
//                       );
//                       const fileName = `${app.Application_Id}_${formattedAwardType}.pdf`;
//                       const fileUrl = `${FILE_BASE_URL}/api/Uploads/ApplicationForms/${fileName}`;
//                       window.open(fileUrl, "_blank");
//                     }}
//                   >
//                     View
//                   </button>
//                 </td>
//                 <td>
//                   <span className="status-label">{app.Status}</span>
//                 </td>
//               </tr>
//             ))
//           )}
//         </tbody>
//       </Table>

//       {/* Modal for Uploading File */}
//       <Modal show={showModal} onHide={() => setShowModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>Upload Agreement</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group controlId="formFile">
//               <Form.Label>
//                 Select File (Upload the PDF of the Agreement)
//               </Form.Label>
//               <Form.Control type="file" onChange={handleFileChange} />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={() => setShowModal(false)}>
//             Cancel
//           </Button>
//           <Button
//             variant="primary"
//             className="modalupdatebutton"
//             onClick={handleFileUpload}
//           >
//             Upload
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }


import React, { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import "./SubmittedApplications.css";
import NavigationBar from "../../Components/NavigationBar";

export default function SubmittedApplications() {
  const [applications, setApplications] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedAppId, setSelectedAppId] = useState(null);
  const [awards, setAwards] = useState([]);
  const [selectedAward, setSelectedAward] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const FILE_BASE_URL = process.env.REACT_APP_FILE_BASE_URL || 'http://localhost:5000/uploads';
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

  const userId = localStorage.getItem("user_id");

  // Fetch applications
  useEffect(() => {
    if (!userId) {
      setError("User ID not found. Please log in.");
      return;
    }
    fetch(`${API_BASE_URL}/getApplicationsByUser/${userId}`)
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setApplications(data);
          setError(null);
        } else {
          console.error("API did not return an array:", data);
          setError("Failed to load applications.");
        }
      })
      .catch((err) => {
        console.error("Error fetching applications:", err);
        setError("Error fetching applications. Please try again.");
      });
  }, [userId, API_BASE_URL]);

  // Fetch awards
  useEffect(() => {
    fetch(`${API_BASE_URL}/getAwards`)
      .then((response) => response.json())
      .then((data) => {
        console.log("Fetched Awards:", data);
        if (Array.isArray(data)) {
          setAwards(data);
        } else {
          console.error("API did not return an array for awards:", data);
          setError("Failed to load awards.");
        }
      })
      .catch((error) => {
        console.error("Error fetching awards:", error);
        setError("Error fetching awards. Please try again.");
      });
  }, [API_BASE_URL]);

  // Generate years up to current year
  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 2024 + 1 },
    (_, i) => 2024 + i
  );

  // Filter applications based on selected award and year
  const filteredApplications = applications.filter((app) => {
    const matchesAward = selectedAward ? app.Award_Type === selectedAward : true;
    const matchesYear = selectedYear
      ? new Date(app.SubmittedDate).getFullYear().toString() === selectedYear
      : true;
    return matchesAward && matchesYear;
  });

  const handleUploadAgreement = (appId) => {
    setSelectedAppId(appId);
    setShowModal(true);
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleFileUpload = () => {
    if (!selectedFile) {
      alert("Please select a file to upload.");
      return;
    }
    if (!selectedAppId) {
      alert("No application selected for upload.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("applicationId", selectedAppId);

    fetch(`${API_BASE_URL}/uploadAgreement`, {
      method: "POST",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        alert("File uploaded successfully!");
        setShowModal(false);
        setSelectedFile(null);
        setSelectedAppId(null);
      })
      .catch((error) => {
        console.error("Error uploading file:", error);
        alert("Error uploading file. Please try again.");
      });
  };

  const handleDeleteClick = (appId) => {
    if (window.confirm("Are you sure you want to delete this application?")) {
      fetch(`${API_BASE_URL}/deleteApplication/${appId}`, {
        method: "DELETE",
      })
        .then((response) => response.json())
        .then((data) => {
          alert("Application deleted successfully.");
          setApplications((prev) =>
            prev.filter((app) => app.Application_Id !== appId)
          );
        })
        .catch((error) => {
          console.error("Error deleting application:", error);
          alert("Error deleting application. Please try again.");
        });
    }
  };

  return (
    <div >
      <NavigationBar />
      <h1 className="page-name" style={{ textAlign: "left" }}>
        Submitted Applications
      </h1>
      {error && <div style={{ color: "red", marginBottom: "10px" }}>{error}</div>}
      <div style={{ margin: "20px 0", display: "flex", gap: "20px", fontWeight: "bold" }}>
        <div>
          <label htmlFor="awardFilter">Filter by Award: </label>
          <select
            id="awardFilter"
            value={selectedAward}
            onChange={(e) => setSelectedAward(e.target.value)}
            style={{
              padding: "5px",
              marginLeft: "10px",
              minWidth: "100px",
              color: "#000",
              backgroundColor: "#fff",
              border: "1px solid #ccc",
            }}
          >
            <option value="">All Awards</option>
            {awards.map((award) => (
              <option key={award.Award_Id} value={award.Name}>
                {award.Name}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label htmlFor="yearFilter">Filter by Year: </label>
          <select
            id="yearFilter"
            value={selectedYear}
            onChange={(e) => setSelectedYear(e.target.value)}
            style={{
              padding: "5px",
              marginLeft: "10px",
              minWidth: "100px",
              color: "#000",
              backgroundColor: "#fff",
              border: "1px solid #ccc",
            }}
          >
            <option value="">All Years</option>
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
      </div>
      <Table
        striped
        bordered
        hover
        style={{
          marginTop: "20px",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
        }}
      >
        <thead>
          <tr>
            <th>Application Id</th>
            <th>Name</th>
            <th>Award Type</th>
            <th>Submitted Date</th>
            <th>View Application</th>
            <th>Status</th>
          
          </tr>
        </thead>
        <tbody>
          {filteredApplications.length === 0 ? (
            <tr>
              <td colSpan="7" style={{ textAlign: "center" }}>
                No applications submitted.
              </td>
            </tr>
          ) : (
            filteredApplications.map((app) => (
              <tr key={app.Application_Id}>
                <td>{app.Application_Id}</td>
                <td>{app.Applicant_Name || app.Name}</td>
                <td>{app.Award_Type}</td>
                <td>{app.SubmittedDate}</td>
                <td>
                  <Button
                    variant="outline-primary"
                    className="View_Button"
                    size="sm"
                    onClick={() => {
                      const formattedAwardType = app.Award_Type.replace(
                        /\s+/g,
                        "_"
                      );
                      const fileName = `${app.Application_Id}_${formattedAwardType}.pdf`;
                      const fileUrl = `${FILE_BASE_URL}/api/Uploads/ApplicationForms/${fileName}`;
                      window.open(fileUrl, "_blank");
                    }}
                  >
                    View
                  </Button>
                </td>
                <td>
                  <span className="status-label">{app.Status}</span>
                </td>
               
              </tr>
            ))
          )}
        </tbody>
      </Table>

      {/* Modal for Uploading File */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Upload Agreement</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formFile">
              <Form.Label>
                Select File (Upload the PDF of the Agreement)
              </Form.Label>
              <Form.Control type="file" onChange={handleFileChange} />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            className="modalupdatebutton"
            onClick={handleFileUpload}
          >
            Upload
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}